import React, { useState, useEffect } from 'react';
import ReactMinimalPieChart from 'react-minimal-pie-chart';

const HeadlineLength = ({ headline, displayFormula }) => {
  const [headlineWords, setHeadlineWords] = useState([]);

  useEffect(() => {
    const charRegex = new RegExp(/^\W{1}$/g);
    const wordArr = headline.split(' ').filter(item => {
      return !charRegex.test(item);
    });

    setHeadlineWords(wordArr);
  }, [headline]);

  const charScore = () => {
    return (headline.length / 160) * 100;
  };

  const charColor = () => {
    const l = headline.length;

    return l > 160 ? '#f8413a' : l < 75 ? '#f8413a' : '#02b250';
  };

  const wordScore = () => {
    return (headlineWords?.length / 25) * 100;
  };

  const wordColor = () => {
    return headlineWords?.length > 25
      ? '#f8413a'
      : headlineWords?.length < 10
      ? '#f8413a'
      : '#02b250';
  };

  const wordDescription = () => {
    return headlineWords?.length > 25
      ? `Your Headline is a bit long. We recommend keeping your headline between 10 - 25 words. Yours is ${headlineWords?.length}. Try making it shorter.`
      : headlineWords?.length < 10
      ? `Your Headline is a bit short. We recommend keeping your headline between 10 - 25 words. Yours is ${headlineWords?.length}. Try making it longer.`
      : "Your Headline is the right length. We recommend keeping your headline between 10 - 25 words. You're right there!";
  };

  const headlineDescription = () => {
    return headline.length > 160
      ? `Your Headline is a bit long. We recommend keeping your headline between 75 - 160 characters. Yours is ${headline.length}. Try making it shorter.`
      : headline.length < 75
      ? `Your Headline is a bit short. We recommend keeping your headline between 75 - 160 characters. Yours is ${headline.length}. Try making it longer.`
      : "Your Headline is the right length. We recommend keeping your headline between 75 - 160 characters. You're right there!";
  };

  return (
    <div
      className={
        displayFormula ? 'py-5 px-1 px-sm-5 bg-light' : 'py-5 px-1 px-sm-5'
      }
    >
      <div className="container">
        <div className="d-flex align-items-center justify-content-center">
          <h1 className="font-weight-bold text-center">
            Your LinkedIn Headline Length
          </h1>
        </div>
        <h6 className="py-2 text-center">
          Your LinkedIn Headline should be concise and value-driven so that
          employers can easily understand what you bring to the table.
        </h6>
        <div className="row">
          <div className="col-lg-2" />
          <div className="col d-flex flex-column align-items-center justify-content-center p-2">
            <div className="hachart position-relative">
              <ReactMinimalPieChart
                animate
                animationDuration={500}
                animationEasing="ease-out"
                cx={50}
                cy={50}
                data={[
                  {
                    title: 'Characters',
                    value: charScore(),
                    color: charColor(),
                  },
                  {
                    title: '',
                    value: 100 - charScore(),
                    color: 'rgba(0, 0, 0, 0.1)',
                  },
                ]}
                label={false}
                lengthAngle={360}
                lineWidth={25}
                onClick={undefined}
                onMouseOut={undefined}
                onMouseOver={undefined}
                paddingAngle={2}
                radius={50}
                rounded={false}
                startAngle={-90}
                viewBoxSize={[100, 100]}
              />
              <div className="graph-label">
                <h1 className="font-weight-bold text-center d-block margin-override">
                  {headline.length}
                </h1>
                <p className="text-center">
                  <span className="font-override">Characters</span>
                </p>
              </div>
            </div>
            <div className="d-md-none mt-3">
              <h6 className="text-center">{headlineDescription()}</h6>
            </div>
          </div>

          <div className="col d-flex align-items-center justify-content-center p-2">
            <div className="hachart position-relative">
              <ReactMinimalPieChart
                animate
                animationDuration={500}
                animationEasing="ease-out"
                cx={50}
                cy={50}
                data={[
                  { title: 'Words', value: wordScore(), color: wordColor() },
                  {
                    title: '',
                    value: 100 - wordScore(),
                    color: 'rgba(0, 0, 0, 0.1)',
                  },
                ]}
                label={false}
                lengthAngle={360}
                lineWidth={25}
                onClick={undefined}
                onMouseOut={undefined}
                onMouseOver={undefined}
                paddingAngle={2}
                radius={50}
                rounded={false}
                startAngle={-90}
                viewBoxSize={[100, 100]}
              />
              <div className="graph-label">
                <h1 className="font-weight-bold text-center d-block margin-override">
                  {headlineWords?.length}
                </h1>
                <p className="text-center">
                  <span className="font-override">Words</span>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-2" />
        </div>

        <div className="row">
          <div className="col-lg-2" />
          <div className="d-none d-md-block col mt-3">
            <div>
              <h6 className="text-center">{headlineDescription()}</h6>
            </div>
          </div>

          <div className="col mt-3">
            <div>
              <h6 className="text-center">{wordDescription()}</h6>
            </div>
          </div>
          <div className="col-lg-2" />
        </div>
      </div>
    </div>
  );
};

export default HeadlineLength;
